import React, { useState } from 'react';
import './Modal.css';

const TramiteTypeDeleteModal = ({ isOpen, tramiteType, onClose, onConfirm }) => {
  const [deleting, setDeleting] = useState(false);

  const handleConfirm = async () => {
    setDeleting(true);
    try {
      await onConfirm();
    } finally {
      setDeleting(false);
    }
  };

  if (!isOpen) return null;

  return (
    <div className="modal-overlay" onClick={() => !deleting && onClose()}>
      <div className="modal-content modal-small" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h2>⚠️ Eliminar Tipo de Trámite</h2>
        </div>

        <div className="modal-body">
          <p>¿Estás seguro de que deseas eliminar este tipo de trámite?</p>
          {tramiteType && (
            <div className="cupl-preview">
              <div className="preview-item">
                <span className="label">Nombre:</span>
                <span className="value">{tramiteType.name}</span>
              </div>
              <div className="preview-item">
                <span className="label">Valor:</span>
                <span className="value">${tramiteType.value?.toLocaleString('es-CO')}</span>
              </div>
            </div>
          )}
          <p className="warning-text">⚠️ Esta acción no se puede deshacer</p>
        </div>

        <div className="modal-actions">
          <button
            type="button"
            className="btn btn-cancel"
            onClick={onClose}
            disabled={deleting}
          >
            Cancelar
          </button>
          <button
            type="button"
            className="btn btn-delete"
            onClick={handleConfirm}
            disabled={deleting}
          >
            {deleting ? '⏳ Eliminando...' : '🗑️ Eliminar'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default TramiteTypeDeleteModal;
